import "@js/lib/bootstrap";
import "@api";
import Vue from 'vue'
import store from "@shared/store";
import { routes } from "./routes";
import moment from "moment-timezone";
import VueMoment from "vue-moment";
import PlaceAutofill from "@tenant/shared/directives/PlaceAutofill";
import VueSignaturePad from "vue-signature-pad";
import VueRouter from "vue-router";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";

import PDFDataCustom from '@shared/components/pdf/PDFDataCustom.vue'
import PDFDocumentShow from '@shared/components/pdf/PDFDocumentShow.vue'

import formStore from "@tenant/app-form/components/form/formStore"
import pageHeader from "@tenant/app-form/components/partials/pageHeader"
import formStoreEmbedded from "@tenant/app-form/components/form/formStoreEmbedded"
import vueAwesomeCountdown from "vue-awesome-countdown"

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from "@fortawesome/vue-fontawesome";

import _ from 'lodash';
Vue.set(Vue.prototype, "_", _);

window.Vue = Vue

Vue.directive("place-autofill", PlaceAutofill);

Vue.use(VueRouter);
Vue.use(VueMoment, { moment });
Vue.use(ElementUI, { locale });
Vue.use(VueSignaturePad);
Vue.use(vueAwesomeCountdown);

Vue.use({
    install(Vue, options) {
        Vue.prototype.$bus = new Vue();
    }
});

Vue.component('form-store', formStore)
Vue.component('page-header', pageHeader)
Vue.component("form-store-embedded", formStoreEmbedded)
Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);
Vue.component("pdf-data-custom", PDFDataCustom);
Vue.component("pdf-document-show", PDFDocumentShow);

Vue.prototype.global = key => Ambition.getGlobal(key);
Vue.prototype.$window = window;
Vue.prototype.$groupBy = (list, keyGetter) => {
    const map = new Map()
    if (list) {
        list.forEach(item => {
            const key = keyGetter(item)
            const collection = map.get(key)
            if (!collection) {
                map.set(key, [item])
            }
        })
    }
    return map
}

const router = new VueRouter({
    mode: "history",
    routes
});

function hasQueryParams(route) {
    return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
    if (!hasQueryParams(to) && hasQueryParams(from)) {
        next({
            name: to.name,
            query: Object.assign(from.query, to.query),
            params: Object.assign(from.params, to.params)
        });
    } else {
        next();
    }
});

const app = new Vue({
    el: "#app-form",
    router,
    store
});

router.replace(window.location.pathname + window.location.search);
